import {jsonRequest} from "./common";
import * as CONFIG from '../config';
import * as is from 'predicates';

/**
 * @typedef {Object} QuotationInput
 * @property {Object} sender
 * @property {Object} recipient
 * @property {Object} services
 * @property {Object} params
 * @property {string} refer
 * @property {string} promo
 * @property {string} collection_date
 */

/**
 * @typedef {Object} CarrierPriceInfo
 * @property {boolean} [no_offer]
 * @property {number} id
 * @property {number} discount
 * @property {string} carrier_code
 * @property {number} total_netto
 * @property {number} total
 * @property {number} basic_margin
 */

/**
 * @typedef {Object} QuotationResult
 * @property {CarrierPriceInfo[]} products
 * @property {string} default
 * @property {boolean} show_info
 * @property {boolean} show_announcement
 * @property {boolean} no_standard
 * @property {boolean} error_message
 */
/**
 *
 * @param {QuotationInput} input
 * @return {Promise<QuotationResult>}
 */

var changed = false;

export function quotation(input) {
    // removing empty string is necessary since IE11 for some reason produces empty values for some fields
    const newInput = {
        ...input,
        sender: removeEmptyStrings(input.sender),
        recipient: removeEmptyStrings(input.recipient)
    };
    if(newInput.clearance && newInput.sender.country != 'PL' && !changed &&
        (newInput.clearance.items[0].country != newInput.sender.country)){
        if (newInput.clearance.items.length == 1){
            newInput.clearance.items[0].country = newInput.sender.country
        }
        changed = true;
    }
    return jsonRequest(CONFIG.API_URL + '/quotation/new', {
        method: 'POST',
        body: newInput,
        credentials: 'include'
    })
        .then(data => {
            // when error occurs
            if (!data.products) {
                return data;
            }
            
            return {
                products: data.order.map(x => data.products[x]),
                default: data.products[data.default],
                show_info: data.show_info,
                show_announcement: data.show_announcement,
                show_info_cod: data.show_info_cod,
                show_info_same_data: data.show_info_same_data,
                show_info_inpost_zone: data.show_info_inpost_zone,
                inpost_zone_hour: data.inpost_zone_hour,
                no_standard: data.no_standard,
                error_message: data.error_message
            }
        });
}

function removeEmptyStrings(obj) {
    return Object.keys(obj)
        .reduce((result, key) => {
            const value = obj[key];
            if (value === '') {
                return result;
            }
            if (is.plainObject(value)) {
                result[key] = removeEmptyStrings(value);
            } else {
                result[key] = value;
            }
            return result;
        }, {});
}